import { render, staticRenderFns } from "./ViolationHistorySkeleton.vue?vue&type=template&id=4a81ae0e&scoped=true"
import script from "./ViolationHistorySkeleton.vue?vue&type=script&lang=js"
export * from "./ViolationHistorySkeleton.vue?vue&type=script&lang=js"
import style0 from "./ViolationHistorySkeleton.scss?vue&type=style&index=0&id=4a81ae0e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81ae0e",
  null
  
)

export default component.exports